var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{attrs:{"id":"jump-to-header"}},[_vm._v(_vm._s(_vm.heading || "View Asset to Image Link"))]),_c('asset-image-link-show',{attrs:{"id":_vm.id,"api_path":_vm.api_path}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }